var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { __decorate, __metadata } from "tslib";
import chmService from "@/core/services/chmService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Grupo_SetorActions } from "@/store/enums/chmEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Grupo_SetorModule = class Grupo_SetorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Grupo_SetorActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            chmService.getFile("Grupo_Setor/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Grupo_Setor.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Grupo_SetorActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            chmService.postFile("Grupo_Setor/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Grupo_SetorActions.POST_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Grupo_SetorActions.POSTRANGE_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor/PostRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Grupo_SetorActions.POSTRANGE_USUARIO_ETAPA_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor/PostRange_Usuario_Etapa_Chamado", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Grupo_SetorActions.PUT_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.put("Grupo_Setor/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Grupo_SetorActions.DELETE_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.delete(`Grupo_Setor/Delete`, data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Grupo_SetorActions.DELETE_RANGE_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.delete("Grupo_Setor/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Grupo_SetorActions.FILTER_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.post("Grupo_Setor/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Grupo_SetorActions.GET_GRUPO_SETOR]() {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = Grupo_SetorActions.GETWITHDISABLED_GRUPO_SETOR]() {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = Grupo_SetorActions.GET_BY_ID_GRUPO_SETOR](data) {
        return new Promise(resolve => {
            chmService.get("Grupo_Setor/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grupo_SetorModule.prototype, _m, null);
Grupo_SetorModule = __decorate([
    Module
], Grupo_SetorModule);
export default Grupo_SetorModule;
//# sourceMappingURL=Grupo_SetorModule.js.map